import { BaseSelect } from '@app/components';
import { packApi } from '@app/store';
import { createColumnHelper, } from '@tanstack/react-table';
import { IPack } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IPack>();

export const PackSelect = ({ label = 'Menus', ...props }: ResourceSelectParentProps<IPack>) => {

  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="100%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="100%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={packApi.useReadManyPacksQuery}
      {...props} />
  );
};
